<template>
<div class="spackageList">
    <div class="filters">
        <div class="add">
            <el-button v-if="permission.btnList.indexOf('A020501')==-1" type="primary" @click="handleAdd">新建专栏</el-button>
        </div>
        <div class="search">
            <el-select v-model="param.status" placeholder="全部状态" class="condition">
                <el-option v-for="item in typeList" :key="item.code" :label="item.name" :value="item.code"> </el-option>
            </el-select>
            <el-input v-model="param.subject" placeholder="请输入商品名称" class="condition"></el-input>
            <el-button type="primary" plain @click="search">搜索</el-button>
        </div>
    </div>
    <div class="result-list btn-operate-list">
        <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="spackageName" label="专栏名称" width="456" class-name="title">
                <template slot-scope="scope">
                    <div class="imageText">
                        <img v-lazy="scope.row.coverurl" :alt="scope.row.subject" preview="spackageList">
                        <div class="imageText-summary">
                            <div class="textBox">
                                <div class="text">
                                    <span class="recommon" v-if="scope.row.isinnerrecomm === 1">推荐</span>{{ scope.row.subject }}
                                </div>
                            </div>
                            <div class="price">
                                <span v-if="scope.row.feetype === 1">免费</span>
                                <span v-else>￥{{scope.row.saleprice}}</span>
                            </div>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="datetime" label="发布时间" class-name="issueTime" width="200"></el-table-column>
            <el-table-column prop="kmccount" label="更新期数" class-name="kmcccount"></el-table-column>
            <el-table-column label="上架状态" class-name="putwayStatus">
                <template slot-scope="scope">
                    <span :class="{'status10': scope.row.status === 10, 'status30': scope.row.status === 30,'status31': scope.row.status === 31}">·{{scope.row.statustext}}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="320" label-class-name="tr">
                <template slot-scope="scope">
                    <div class="tr">
                        <!-- 已上架 -->
                        <div v-if="scope.row.status === 30" class="item">
                            <el-button @click="handleContentMgt(scope.row)" v-if="permission.btnList.indexOf('A020510')==-1" type="text" size="small">内容管理</el-button>
                            <span class="separator" v-if="permission.btnList.indexOf('A020510')==-1">|</span>
                            <el-button @click="soldOut(scope.row)" v-if="permission.btnList.indexOf('A020504')==-1" type="text" size="small">下架</el-button>
                            <span class="separator" v-if="permission.btnList.indexOf('A020504')==-1">|</span>
                            <Share :row="scope.row"></Share>
                            <el-button @click="handleEdit(scope.row)" v-if="permission.btnList.indexOf('A020502')==-1" type="text" size="small">编辑</el-button>
                            <span class="separator" v-if="permission.btnList.indexOf('A020502')==-1">|</span>
                            <el-dropdown>
                                <span class="el-dropdown-link">
                                    <el-button type="text" size="small">更多</el-button>
                                </span>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item @click.native="stopToUpdate(scope.row)" v-if="scope.row.isupdate === 1">停止更新</el-dropdown-item>
                                    <el-dropdown-item @click.native="beginToUpdate(scope.row)" v-if="scope.row.isupdate === 0">开始更新</el-dropdown-item>
                                    <el-dropdown-item @click.native="handleDel(scope.row)" v-if="permission.btnList.indexOf('A020509')==-1">删除</el-dropdown-item>
                                    <el-dropdown-item @click.native="handleRecommend(scope.row)" v-if="permission.btnList.indexOf('A020507')==-1 && scope.row.isinnerrecomm === 2 || scope.row.isinnerrecomm === 0">加入推荐</el-dropdown-item>
                                    <el-dropdown-item @click.native="cancelRecommend(scope.row)" v-if="permission.btnList.indexOf('A020507')==-1 && scope.row.isinnerrecomm === 1">取消推荐</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>
                        <!-- 已下架 -->
                        <div v-if="scope.row.status === 31" class="item">
                            <el-button @click="handleContentMgt(scope.row)" v-if="permission.btnList.indexOf('A020510')==-1" type="text" size="small">内容管理</el-button>
                            <span class="separator" v-if="permission.btnList.indexOf('A020510')==-1">|</span>
                            <el-button @click="putAway(scope.row)"  v-if="permission.btnList.indexOf('A020503')==-1" type="text" size="small">上架</el-button>
                            <span class="separator" v-if="permission.btnList.indexOf('A020503')==-1">|</span>
                            <Share :row="scope.row"></Share>
                            <el-button @click="handleEdit(scope.row)" v-if="permission.btnList.indexOf('A020502')==-1" type="text" size="small">编辑</el-button>
                            <span class="separator" v-if="permission.btnList.indexOf('A020502')==-1">|</span>
                            <el-button @click="handleDel(scope.row)" v-if="permission.btnList.indexOf('A020509')==-1" type="text" size="small">删除</el-button>
                        </div>
                        <!-- 待上架 -->
                        <div v-if="scope.row.status === 10" class="item">
                            <el-button @click="handleContentMgt(scope.row)" v-if="permission.btnList.indexOf('A020510')==-1" type="text" size="small">内容管理</el-button>
                            <span class="separator" v-if="permission.btnList.indexOf('A020510')==-1">|</span>
                            <el-button @click="handleEdit(scope.row)" v-if="permission.btnList.indexOf('A020502')==-1" type="text" size="small">编辑</el-button>
                            <span class="separator" v-if="permission.btnList.indexOf('A020502')==-1">|</span>
                            <el-button @click="handleDel(scope.row)" v-if="permission.btnList.indexOf('A020509')==-1" type="text" size="small">删除</el-button>
                        </div>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <page :total="total" @getList="_getList" ref="page"></page>
    </div>
</div>
</template>

<script>
import Page from 'base/page/page'
import {mapGetters, mapActions} from 'vuex'
import Share from 'base/share/share'
import {promiseUrlToQRCode} from 'common/js/tools'
import {getSpackageList, delAndPutaway, recommend, specialUpdate} from '@/api/spackageApi'
export default {
    name: 'spackageList',
    data() {
        return {
            logo: require('@/common/images/index/logo.png'),
            typeList: [
                {code: '', name: '全部状态'},
                {code: '10', name: '待上架'},
                {code: '30', name: '已上架'},
                {code: '31', name: '已下架'}
            ],
            total: 0,
            param: {
                subject: '',
                status: ''
            },
            tableData: []
        }
    },
    created() {
    },
    beforeRouteEnter (to, from, next) {
        next(v => {
            if (v.$route.query.refresh === '1') {
                let page = {
                    page: 1,
                    pageSize: 10
                }
                v.setPage(page)
                v.$refs.page.pagination.page = 1
                v._getList()
            } else if (v.$route.query.refresh === '0') {
                v._getList()
            }
        })
    },
    mounted() {
        this.getList()
    },
    methods: {
        handleEdit(row) {
            this.$router.push({name: 'SpackageEdit', query: {innerid: row.innerid}})
        },
        // 删除
        handleDel(row) {
            this.$confirm('确定将该商品删除吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                delAndPutaway({
                    data: {innerid: row.innerid, status: '100'},
                    success: data => {
                        if (data.code === '000') {
                            this.getList()
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            })
                        }
                    },
                    error: data => {
                        this.$message.error(data.msg)
                    }
                })
            }).catch(() => {})
        },
        // 加入推荐
        handleRecommend(row) {
            this.$confirm('确定将该商品加入推荐吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                recommend({
                    data: Object.assign({innerid: row.innerid, isinnerrecomm: '1'}),
                    success: data => {
                        if (data.code === '000') {
                            this.getList()
                            this.$message({
                                type: 'success',
                                message: '推荐成功'
                            })
                        }
                    },
                    error: data => {
                        this.$message.error(data.msg)
                    }
                })
            }).catch(() => {})
        },
        // 取消推荐
        cancelRecommend(row) {
            this.$confirm('确定将该商品取消推荐吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                recommend({
                    data: Object.assign({innerid: row.innerid, isinnerrecomm: '2'}),
                    success: data => {
                        if (data.code === '000') {
                            this.getList()
                            this.$message({
                                type: 'success',
                                message: '取消推荐成功'
                            })
                        }
                    },
                    error: data => {
                        this.$message.error(data.msg)
                    }
                })
            }).catch(() => {})
        },
        // 下架
        soldOut(row) {
            this.$confirm('确定需要将该商品下架吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                delAndPutaway({
                    data: {innerid: row.innerid, status: '31'},
                    success: data => {
                        if (data.code === '000') {
                            this.getList()
                            this.$message({
                                type: 'success',
                                message: '下架成功'
                            })
                        }
                    },
                    error: data => {
                        this.$message.error(data.msg)
                    }
                })
            }).catch(() => {})
        },
        // 上架
        putAway(row) {
            this.$confirm('确定需要将该商品上架吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                delAndPutaway({
                    data: {innerid: row.innerid, status: '30'},
                    success: data => {
                        if (data.code === '000') {
                            this.getList()
                            this.$message({
                                type: 'success',
                                message: '上架成功'
                            })
                        }
                    },
                    error: data => {
                        this.$message.error(data.msg)
                    }
                })
            }).catch(() => {})
        },
        // 停止更新
        stopToUpdate(row) {
            this.$confirm('确定要将该商品停止更新吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                specialUpdate({
                    data: {innerid: row.innerid, isupdate: 0},
                    success: data => {
                        if (data.code === '000') {
                            this.getList()
                            this.$message({
                                type: 'success',
                                message: '停止更新成功!'
                            })
                        }
                    },
                    error: data => {
                        this.$message.error(data.msg)
                    }
                })
            }).catch(() => {})
        },
        // 开始更新
        beginToUpdate(row) {
            this.$confirm('确定将该商品开始更新吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                specialUpdate({
                    data: {innerid: row.innerid, isupdate: 1},
                    success: data => {
                        if (data.code === '000') {
                            this.getList()
                            this.$message({
                                type: 'success',
                                message: '开始更新成功!'
                            })
                        }
                    },
                    error: data => {
                        this.$message.error(data.msg)
                    }
                })
            }).catch(() => {})
        },
        // 内容管理
        handleContentMgt(row) {
            this.$router.push({name: 'SpackageContentMgt', query: {innerid: row.innerid}})
        },
        // 新建专题
        handleAdd() {
            if (this.shop.authstatus === 0) {
                this.$confirm('该功能需要在开通企业版或者单独工具基础上方可使用，建议尽快购买，购买后可继续使用该功能', '提示', {
                    confirmButtonText: '去购买',
                    cancelButtonText: '取消'
                }).then(() => {
                    // 去购买
                    this.$router.push({name: 'OrderService'})
                }).catch(() => {
                    // 取消不做处理
                })
            } else {
                this.$router.push({name: 'SpackageEdit'})
            }
            // this.$router.push({name: 'SpackageEdit'})
        },
        // 获取列表数据
        _getList(page) {
            this.setLoading(true)
            getSpackageList({
                data: Object.assign({}, this.$refs.page.page, this.param),
                success: data => {
                    this.setLoading(false)
                    if (data.data) {
                        data.data.forEach(obj => {
                            promiseUrlToQRCode(obj.shareurl, obj.coverurl).then(
                                function(data) {
                                    obj.qrShare = data
                                },
                                function(reason, data) {
                                    console.log('二维码生成失败：', reason)
                                }
                            )
                        })
                        this.tableData = data.data
                    } else {
                        this.tableData = []
                    }

                    this.total = data.pageableData.rowCount
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        // 初始化页面数据
        getList() {
            this.setLoading(true)
            getSpackageList({
                data: Object.assign({page: 1, pageSize: 10}, this.param),
                success: data => {
                    this.setLoading(false)
                    data.data.forEach(obj => {
                        promiseUrlToQRCode(obj.shareurl, obj.coverurl).then(
                            function(data) {
                                obj.qrShare = data
                            },
                            function(reason, data) {
                                console.log('二维码生成失败：', reason)
                            }
                        )
                    })
                    this.tableData = data.data
                    this.total = data.pageableData.rowCount
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(false)
                }
            })
        },
        // 搜索
        search() {
            this._getList(this.$refs.page.page)
        },
        ...mapActions([
            'setLoading',
            'setPage'
        ])
    },
    filters: {
        status (value) {
            let cls = ''
            switch (value) {
            case 12: cls = '暂停'
                break
            case 0: cls = '草稿'
                break
            case 11: cls = '审核失败'
                break
            case 10: cls = '待上架'
                break
            case 30: cls = '已上架'
                break
            case 31: cls = '已下架'
                break
            case 100:
                cls = '删除'
                break
            case 1:
                cls = '待审核'
                break
            }
            return cls
        }
    },
    watch: {},
    computed: {
        status () {
            return function(value) {
                let cls = ''
                switch (value) {
                case 1: cls = 'doing'
                    break
                case 2: cls = 'success'
                    break
                case 3: cls = 'error'
                    break
                case 4: cls = 'complete'
                    break
                default:
                    cls = 'fail'
                }
                return cls
            }
        },
        ...mapGetters([
            'page',
            'user',
            'permission',
            'shop'
        ])
    },
    components: {
        Page, Share
    }
}
</script>
<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/base";
@import "~common/scss/mixin";
.spackageList {
    .result-list{
        .el-table__row{
            height: 100px;
        }
        .imageText{
            display: flex;
            width: 100%;
            height: 100%;
            img{
                min-width: 106px;
                max-width: 106px;
                height: 60px;
            }
            .imageText-summary{
                .textBox{
                    width: 345px;
                    height: 40px;
                    line-height: 20px;
                    overflow: hidden;
                    .text{
                        float: right;
                        /* "margin-left"要等于".wrap::before"的宽度 */
                        margin-left: -10px;
                        width: 340px;
                        word-break: break-all;
                        // font-size: 0.48rem;
                    }
                    &::before {
                        float: left;
                        content: '';
                        width: 10px;
                        height: 100%;
                    }
                    &::after {
                        float: right;
                        content: "...";
                        /* 行高与".wrap"设置的一致即可 */
                        height: 40px;
                        line-height: 20px;
                        /* 设置三个省略号的宽度,大于字体文本宽度即可,数值随意。并使盒子不占位置 */
                        width: 37px;
                        margin-left: -30px;
                        position: relative;
                        left: 96%;
                        bottom: 20px;
                        font-weight: 600;
                        padding-right: 1px;
                        background: #fff;
                        transition: all 0.5s;
                    }
                    .recommon{
                        color: #fff;
                        background: #E6A23C;
                        display: inline-block;
                        width: 36px;
                        height: 16px;
                        line-height: 16px;
                        text-align: center;
                        margin-right: 5px;
                        font-size: 12px;
                    }
                }
                .price{
                    margin-left: 5px;
                    color: #F56C6C;
                }
            }
        }
        .el-table__row:hover{
            .textBox{
                &::after{
                    background: #F5F7FA;
                }
            }
        }
        .status10{
            color: #409EFF;
        }
        .status30{
            color: #67C23A;
        }
        .status31{
            color: #909399;
        }
        .issueTime,.ordercount,.kmcccount,.putwayStatus{
            .cell{
                text-align: center;
            }
        }
        .tr{
            span{
                color: #409EFF;
                // margin-left: 5px;
            }
            .item{
                display: flex;
                justify-content: flex-end;
            }
        }
    }
}
.result-list .imageText .imageText-summary div:nth-child(1){
    margin-bottom: 0 !important;
}
.el-table{
    .title{
        .cell{
            padding: 0;
            margin-left: 5px;
        }
    }
}
.el-popover{
    .spackageList-pr-code-upload{
        text-align: center;
        img{
            width: 160px;
            height: 160px;
        }
        .pr-code-text{
            color: $tcolor-blue;
            padding: 20px 0;
        }
        .btn-operate{
            @include flexBox(space-between);
            .el-input,input{
                width: 210px;
                height: 36px;
                line-height: 36px;
            }
            .el-button{
                min-width: 60px;
            }
        }
    }
}
</style>
